module.exports = __webpack_public_path__ + "img/16.c86b1c87.jpg";